/**
 * The sector form's view of `tags`.
 *
 * The behaviour lives in {@link ../common/dataTags.util}, shared with the profile form. All the
 * sector adds is which keys already have a labelled field of their own, so the raw editor does not
 * offer a second control for a value the form is already editing.
 */
import {DataTags, editableDataTags, mergeDataTags} from "../common/dataTags.util";

/** Tags that already have a labelled field on the sector form. The field stays authoritative. */
export const CANCELLATION_PHONE_TAG = 'CANCELLATION_PHONE'

const DEDICATED_TAG_KEYS: readonly string[] = [CANCELLATION_PHONE_TAG]

export type SectorTags = DataTags

export const editableSectorTags = (tags?: SectorTags | null): Record<string, string> => (
    editableDataTags(tags, DEDICATED_TAG_KEYS)
)

export const mergeSectorTags = (existing?: SectorTags | null, edited?: DataTags | null): SectorTags => (
    mergeDataTags(existing, edited, DEDICATED_TAG_KEYS)
)
